import G from "./Glob.mjs";

/**
 * @private
 * @type {true|undefined}
 */
let setupDone;

/**
 * Setup, performed only once
 * @return {void}
 */
export const appBootstrapSetup = () => {
	if ( setupDone ) return;
	G.setupApp({
		homePage: 'ListLibraries',
		appRootNode: 'athena-setup-client-app-root-node',
		keyApplicationName: 'athena-setup-client',
		usernameKey: 'user',
		uri : {
			onlinebackend : '/backend/',
			offlinebackend : 'http://localhost:3065/db/athenalibraries/libs/ops/',
		}
	});
	setupDone = true;
}

if ( ! setupDone ) appBootstrapSetup();

export default appBootstrapSetup;
